module.exports = __webpack_public_path__ + "img/logo-tapaj.03ae3397.png";